export { composeAuthor, parseAuthor } from './author.js';
export { default } from './packagejson.js';
